import { createFileRoute } from '@tanstack/react-router'
import { ShipmentsSection, shipmentsLoader } from '@spcc/domains/shipments'

export const Route = createFileRoute('/shipments')({
  loader: shipmentsLoader,
  component: ShipmentsPage,
})

function ShipmentsPage() {
  return <ShipmentsSection />
}
